/**
 * Reads an own property only, so keys such as metric names "constructor" or "__proto__" never
 * resolve to Object.prototype members.
 */
export function getOwnRecordValue<TValue>(
  record: Readonly<Record<string, TValue>> | undefined,
  key: string,
): TValue | undefined {
  return record !== undefined && Object.prototype.hasOwnProperty.call(record, key)
    ? record[key]
    : undefined;
}
